<div class="row g-0 py-1 px-3 align-items-center text-dark">
  <div class="col-2" style="min-width: 12rem" [title]="model.consignmentNumber">
    {{ model.consignmentNumber }}
  </div>
  <div class="col-2 small text-secondary cut-text" style="min-width: 12rem" [title]="model.dischargeTerminal ?
        (model.dischargeTerminal?.terminalCode ?? '') + ' - ' + (model.dischargeTerminal?.terminalName ?? '') : ''">
    <span class="fa fa-sign-out-alt"></span>
    {{ model.dischargeTerminal ? model.dischargeTerminal?.terminalName : "" }}
  </div>
  <div class="col-3 small text-secondary cut-text" style="min-width: 12rem" [title]="model.placeOfDestination ?
        (model.placeOfDestination?.locationUnCode ?? '') + ' - ' + (model.placeOfDestination?.name ?? '') : ''">
    <span class="fa fa-sign-in-alt"></span>
    {{ model.placeOfDestination ? model.placeOfDestination?.name : "" }}
  </div>
  <div class="col-2">
    @if (model.ataFirstBerth) {
      ATA: {{ formatDate(model.ataFirstBerth) }}
    }
  </div>
  @if (!model.cancelled) {
    <div class="col-auto ms-auto d-flex justify-content-end">
      @if (midPhaseType(); as type) {
        <span class="mx-1 text-center">
          <span class="badge rounded-pill align-text-bottom" [ngClass]="'text-bg-' + type">{{ midPhase() }}</span>
        </span>
      }
      @if (renPhaseType(); as type) {
        <span class="mx-1 text-center">
          <span class="badge rounded-pill align-text-bottom" [ngClass]="'text-bg-' + type">{{ renPhase() }}</span>
        </span>
      }
    </div>
  }
  @if (model.cancelled) {
    <div class="col-auto ms-auto d-flex justify-content-end" style="min-width: 12rem">
      <span class="badge rounded-pill align-text-bottom" [ngClass]="'text-bg-secondary'">Cancelled</span>
    </div>
  }
</div>
